import { render, staticRenderFns } from "./HeaderCategoriesMobile.vue?vue&type=template&id=6b08468f&"
import script from "./HeaderCategoriesMobile.vue?vue&type=script&lang=js&"
export * from "./HeaderCategoriesMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports